import * as React from 'react';
import classnames from 'classnames';
import './index.scss';

interface Props {
    children: React.ReactNode;
    font: 'primary' | 'secondary' | 'description'
    weight?: 'w300' | 'bold';
    size?: 15 | 20 | 25 | 30 | 40 | 50; 
    lineHeight?: number; 
}

const Font = ({font, weight, children, size = 25, lineHeight = 1.8}: Props) => (
    <div className={classnames('font', font, weight, {
        [`s-${size}`]: size,
        [`l-${lineHeight}`]: lineHeight
    })}>{children}</div>
);

export default Font;


// WEBPACK FOOTER //
// ./src/components/layout/Font/index.tsx